// Obtiene los parámetros de la url actual
const url_actual = window.location.search;
// Si tiene parámetros...
if(url_actual != ''){
    const parametros = new URLSearchParams(url_actual);
    // ... y en concreto el variant
    var variante = parametros.get('variant')

    // Simula el checked del input
    var elemento = document.getElementById('swatch-' + variante);
    elemento.checked = true;
}else{
    var elemento = document.querySelector('.opcion-tarjeta-1');
    var variante = elemento.getAttribute('data-value');
    document.getElementById('swatch-' + variante).checked = true;
}